import { BlockComponentModel } from '@/cms/types/blok-component';

import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import { RichTextFieldStrapiProps } from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { FeatureListStrapiProps } from '@/decodo/features/FeatureListStrapi/FeatureListStrapiDC';

import { ImageStrapiProps } from '@/decodo/components/atoms/Image/ImageStrapi';
import { HomepageHero } from './HomepageHero';
import { transformStrapiHomepageHero } from './transformer';

export type HomepageHeroStrapiProps = {
  title?: string;
  description?: RichTextFieldStrapiProps;
  buttons?: LinkButtonStrapiProps[];
  showMoneyBack?: boolean;
  extraButton?: 'googleSignIn';
  extraButtonLink?: string;
  extraButtonText?: string;
  featureList?: FeatureListStrapiProps;
  carousel?: {
    carouselContent: {
      badgeText?: string;
      cardTitle?: string;
      cardDescription?: RichTextFieldStrapiProps;
      image: ImageStrapiProps;
    }[];
  };
};

export function HomepageHeroStrapi({
  block,
}: BlockComponentModel<HomepageHeroStrapiProps>) {
  return <HomepageHero {...transformStrapiHomepageHero(block)} />;
}
